import React, { type FC, type ReactNode } from 'react';

export interface RadioButtonProps {
    className?: string;
    testId?: string;
    isActive?: boolean;
    onClick?: () => void;
}

const RadioButton: FC<RadioButtonProps> = props => {
    const { isActive = false, className, onClick } = props;

    function getClassName(): string {
        const base = 'transition flex items-center justify-center cursor-pointer border rounded-full h-4 w-4';
        if (isActive) return `${base} border-primary-500`;
        return `${base} border-gray-500`;
    }

    function getFillClassName(): string {
        const base = 'transition rounded-full scale-0 h-3 w-3';
        if (isActive) return `${base} bg-primary-500 scale-100`;
        return base;
    }

    function renderFill(): ReactNode {
        return <div className={getFillClassName()}></div>;
    }

    return (
        <div onClick={onClick} className={`relative ${getClassName()} ${className}`}>
            {renderFill()}
        </div>
    );
};

export default RadioButton;
